import {
    MobileBonusBannerCloseWrapperStyled,
    MobileBonusBannerContainerStyled,
    MobileBonusBannerContentStyled,
    MobileBonusBannerDescriptionStyled,
    MobileBonusBannerStyled,
    MobileBonusBannerTitleStyled
} from "./styled/MobileBonusBannerStyled";
import { BinIcon } from "../../../components/icon/Icon";
import { useCallback } from "react";

function MobileBonusBanner(props) {
    const {
        allowClose,
        children,
        description,
        handleClose,
        onBannerClick,
        rightComponent,
        title,
    } = props;

    const onCloseClick = useCallback((e) => {
        e.stopPropagation();
        handleClose(e);
    }, [handleClose]);

    return <MobileBonusBannerStyled
        className={'mobile-bonus-banner'}
        onClick={onBannerClick}
    >
        <MobileBonusBannerContentStyled>
            <MobileBonusBannerContainerStyled>
                <MobileBonusBannerTitleStyled>
                    {title}
                </MobileBonusBannerTitleStyled>
                {!!rightComponent && rightComponent}
                {
                    !!allowClose && <MobileBonusBannerCloseWrapperStyled onClick={onCloseClick}>
                        <BinIcon name={'IcClose'}/>
                    </MobileBonusBannerCloseWrapperStyled>
                }
            </MobileBonusBannerContainerStyled>
            <MobileBonusBannerDescriptionStyled>
                {description}
            </MobileBonusBannerDescriptionStyled>
            {!!children && <div className={'d-flex flex-column mt-2'}>
                {children}
            </div>}
        </MobileBonusBannerContentStyled>
    </MobileBonusBannerStyled>
}

export default MobileBonusBanner;
